<template>
  <div
    v-if="media"
    :class="[blockClass + '__media', !customImage.src && 'is-active']"
  >
    <responsive-image
      v-if="media.image || customImage.src"
      :image="customImage.src ? customImage : media.image"
      :ratio="ratio"
      sizes="550px"
    />

    <div
      v-if="!customImage.src"
      :class="[blockClass + '__media-content']"
    >
      <div
        v-if="media.title"
        class="text-heading-xl"
        :class="[blockClass + '__media-title']"
        v-text="media.title"
      />

      <btn
        v-if="media.ctaLink && media.ctaTitle"
        :label="media.ctaTitle"
        :url="media.ctaLink"
        modifiers="primary dark"
      />
    </div>
  </div>
</template>

<script>

/**
 * Vue: Media Block (menu-drawer)
 * -----------------------------------------------------------------------------
 * Mobile media blocks.
 *
 * @param {String} blockClass - Root class that's used on all the elements.
 * @param {Object} media - Media object including image, title and CTA.
 * @param {String} ratio - Image ratio.
 * @param {Object} customImage - Custom image (used for hover images).
 */

import ResponsiveImage from '~global/images/responsive-image'
import Btn from '~global/btn/btn'

export default {
  name: 'MediaBlock',

  components: {
    ResponsiveImage,
    Btn,
  },

  props: {
    blockClass: {
      type: String,
      default: 'media-block',
    },
    media: {
      type: Object,
      default: () => ({}),
    },
    ratio: {
      type: String,
      default: '1:1',
    },
    customImage: {
      type: Object,
      default: () => ({}),
    },
  },
}
</script>
